// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {ImageSrc} from 'docs/markdoc/attribute-types';

export const FlowChartRow: MarkdocTagRegistration = {
  tag: 'flow-chart-row',
  component: 'FlowChartRow',
  attributes: {
    title: {type: String, localizable: true},
    image: {type: ImageSrc},
    icon: {
      type: String,
      matches: [
        'authorize',
        'canceled',
        'capture',
        'card-authentication-line',
        'collect-card',
        'created',
        'failed',
        'processing',
        'requires-action-line',
        'requires-confirmation',
        'requires-payment-method',
        'succeeded',
        'verified',
      ],
    },
    type: {type: String},
    border: {
      type: String,
      matches: ['solid', 'fade', 'none'],
    },
    badge: {type: String},
  },
};
